import * as Actions from '../../actions/laborClass/type';

const initialState = {
  loading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,
  laborClasses: [],
  newLaborClass: {},
  updatedLaborClass: {},
  deletedLaborClass: {},
  createLaborClassError: '',
  updateLaborClassError: '',
  deleteLaborClassError: '',
};
export const laborClassReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get All Labor Classes
    case Actions.GET_LABOR_CLASS_LISTING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Actions.GET_LABOR_CLASS_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        laborClasses: action?.payload?.data || [],
      };
    case Actions.GET_LABOR_CLASS_LISTING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    // Create Labor Classe
    case Actions.CREATE_LABOR_CLASS_REQUEST:
      return {
        ...state,
        createLoading: true,
      };
    case Actions.CREATE_LABOR_CLASS_SUCCESS:
      return {
        ...state,
        createLoading: false,
        newLaborClass: action?.payload?.data || {},
      };
    case Actions.CREATE_LABOR_CLASS_FAIL:
      return {
        ...state,
        createLoading: false,
        createLaborClassError: action.payload,
      };
    // Update Labor Classe
    case Actions.UPDATE_LABOR_CLASS_REQUEST:
      return {
        ...state,
        updateLoading: true,
      };
    case Actions.UPDATE_LABOR_CLASS_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        updatedLaborClass: action?.payload?.data || {},
      };
    case Actions.UPDATE_LABOR_CLASS_FAIL:
      return {
        ...state,
        updateLoading: false,
        updateLaborClassError: action.payload,
      };
    // Delete Labor Classe
    case Actions.DELETE_LABOR_CLASS_REQUEST:
      return {
        ...state,
        deleteLoading: true,
      };
    case Actions.DELETE_LABOR_CLASS_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        deletedLaborClass: action?.payload?.data || {},
      };
    case Actions.DELETE_LABOR_CLASS_FAIL:
      return {
        ...state,
        deleteLoading: false,
        deleteLaborClassError: action.payload,
      };

    case Actions.UPDATE_LABOR_CLASS_LIST:
      let laborClasses = state.laborClasses;
      const payloadData = action?.payload?.data;
      if (action.insert) {
        // if new laborClass isDefault true then othe class will be false
        if (payloadData?.isDefault) {
          const labIndex = laborClasses?.findIndex((lab) => lab?.isDefault);
          if (labIndex > -1) {
            laborClasses[labIndex].isDefault = false;
          }
        }
        // if new labot class created
        laborClasses = [...laborClasses, payloadData];
      } else if (action.update) {
        // if new laborClass isDefault true then othe class will be false
        if (payloadData?.isDefault) {
          const labIndex = laborClasses?.findIndex(
            (lab) => lab?.isDefault && lab.id !== payloadData.id,
          );
          if (labIndex > -1) {
            laborClasses[labIndex].isDefault = false;
          }
        }

        // if  labor class updated
        const foundIndex = laborClasses.findIndex(
          (item) => item.id === payloadData.id,
        );
        if (foundIndex > -1) {
          laborClasses[foundIndex] = payloadData;
        }
      } else if (action.delete) {
        // if  labor class deleted
        laborClasses = laborClasses.filter(
          (data) => data.id !== payloadData.id,
        );
      }
      return {
        ...state,
        laborClasses: [...laborClasses],
      };
    case Actions.CLEAR_LABOR_STATE:
      return {
        ...state,
        newLaborClass: {},
        updatedLaborClass: {},
        deletedLaborClass: {},
      };
    default:
      return state;
  }
};
